const SMEPAY_ENABLED =
  String(process.env.REACT_APP_SMEPAY_ENABLED || "")
    .toLowerCase()
    .trim() === "true";

const API = {
  start: "/api/smepay/start",
  status: "/api/smepay/status",
  validate: "/api/smepay/validate",
};

export function isSmepayCheckoutEnabled() {
  return SMEPAY_ENABLED;
}

export async function smepayStartPayment(body) {
  const res = await fetch(API.start, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  return { res, data };
}

export async function smepayPollStatus(smepayOrderId) {
  const res = await fetch(API.status, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ smepayOrderId }),
  });
  const data = await res.json().catch(() => ({}));
  return { res, data };
}

export async function smepayValidatePayment(slug, amount) {
  const res = await fetch(API.validate, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ slug, amount }),
  });
  const data = await res.json().catch(() => ({}));
  return { res, data };
}

export function loadSmepayWizardScript() {
  return new Promise((resolve, reject) => {
    if (typeof window !== "undefined" && typeof window.smepayCheckout === "function") {
      resolve();
      return;
    }
    const existing = document.querySelector('script[data-smepay-wizard="1"]');
    if (existing) {
      existing.addEventListener("load", () => resolve());
      existing.addEventListener("error", () =>
        reject(new Error("Failed to load SMEPay checkout script")),
      );
      return;
    }
    const s = document.createElement("script");
    s.src = "https://typof.co/smepay/checkout-v2.js";
    s.async = true;
    s.dataset.smepayWizard = "1";
    s.onload = () => resolve();
    s.onerror = () => reject(new Error("Failed to load SMEPay checkout script"));
    document.body.appendChild(s);
  });
}
